import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-16 h-16 text-stone-400 mx-auto"/>
      <h1 className="mt-6 text-3xl tracking-tighter font-light">Purchase cancelled</h1>
      <p className="text-stone-600 mt-2">No charges were made. You can try again anytime.</p>
      <Link to="/marketplace"><Button className="mt-6 bg-[#2C5530] hover:bg-[#1F3D22] text-white rounded-full h-11 px-6">Back to marketplace</Button></Link>
    </div>
  );
}
